<template>
    <div>
        <el-dialog align-center v-model="state.dialogVisible" :title="dialogTitle" width="800" draggable>
            <div class="userAdd_man">
                <el-form ref="ruleForm" label-width="auto" :model="state.form" :rules="rules" class="userFrom">
                    <el-col :span="24" style="margin-bottom: 20px;">
                        <el-form-item :label="t('personnelDialog.device')" prop="device_list_id">
                            <el-select v-model="state.form.device_list_id" :placeholder="t('personnelDialog.selectDevice')" filterable multiple clearable popper-class="custom-header">
                                <template #header>
                                    <el-checkbox v-model="checkAll" :indeterminate="indeterminate" @change="handleCheckAll">
                                        {{ t('common.all') }}
                                    </el-checkbox>
                                </template>
                                <el-option v-for="item in state.options" :key="item.value" :label="item.label" :value="item.value" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <template #footer>
                <el-button @click="state.dialogVisible = false">{{ t('common.cancel') }}</el-button>
                <el-button type="primary" @click="submit" :loading="state.loading">{{ t('common.confirm') }}</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { reactive, ref, defineEmits, defineProps, defineExpose, computed, toRaw } from "vue";
import { ElMessage } from "element-plus";
import { newbindMachineApi } from "@/api/machinist/detail.js";
import { pageListApi as getDeviceOptionsApi } from "@/api/system/device.js";
import { usePageI18n, t } from "@/composables/usePageI18n.js";

const indeterminate = ref(false);
const checkAll = ref(false);
const emit = defineEmits(['refresh']);
const props = defineProps({
    title: { type: String, default: '' },
    user_id: { type: Number, default: 0 },
});

const dialogTitle = computed(() => props.title || t('personnelDialog.bindDevice'));
const rules = computed(() => ({
    device_list_id: [{ required: true, message: t('personnelDialog.selectDevice'), trigger: 'blur' }],
}));

const state = reactive({
    dialogVisible: false,
    form: { id: 0, user_id: 0, device_list_id: [] },
    options: [],
    loading: false,
});

const handleCheckAll = () => {
    if (indeterminate.value) {
        indeterminate.value = false;
        state.form.device_list_id = [];
    } else {
        indeterminate.value = true;
        state.form.device_list_id = state.options.map(e => e.value);
    }
};

const getDeviceOptions = () => {
    getDeviceOptionsApi({ page: 1, limit: 10000, keywords: "", model: "", status: 99 }).then(res => {
        if (res?.code === 200) {
            state.options = (res?.data || []).map(i => ({
                value: i.id,
                label: `${i.manufacturer}-${i.title}(${i.code})`,
            }));
        }
    });
};

const open = (row) => {
    getDeviceOptions();
    if (row?.id) state.form = { ...row };
    state.dialogVisible = true;
};

const ruleForm = ref(null);
const submit = () => {
    ruleForm.value.validate((valid) => {
        if (!valid) return false;
        state.loading = true;
        newbindMachineApi(JSON.stringify({
            ...toRaw(state.form),
            user_id: props.user_id,
            device_list_id: state.form.device_list_id,
        })).then(res => {
            if (res?.code === 200) {
                ElMessage.success(t('common.success'));
                state.dialogVisible = false;
                emit('refresh');
            }
        }).finally(() => { state.loading = false; });
    });
};

usePageI18n(() => {});
defineExpose({ open, state });
</script>

<style lang="less" scoped>
.userAdd_man { padding: 0 30px; }
</style>
